// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AlertProvider } from './contexts/geral/AlertContext';
import { MessageProvider } from './contexts/geral/MessageContext';
import { TokenProvider } from './contexts/geral/TokenContext';
import { UserProvider } from './contexts/geral/UserContext';
import { YesNoProvider } from './contexts/geral/YesNoContext';
import { ModalStackProvider } from './contexts/geral/ModalStackContext';
import App from './App';

// Roda o evento 'beforeinstallprompt' para evitar que o prompt de instalação seja exibido automaticamente
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
});

// ✅ Adiciona dinamicamente a div de impressão fora do React
const printArea = document.createElement('div');
printArea.id = 'conteudo-impressao';
printArea.style.display = 'none'; // oculta por padrão
document.body.appendChild(printArea);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ModalStackProvider>
      <AlertProvider>
        <MessageProvider>
          <YesNoProvider>
            <TokenProvider>
              <UserProvider>
                <App />
              </UserProvider>
            </TokenProvider>
          </YesNoProvider>
        </MessageProvider>
      </AlertProvider>
    </ModalStackProvider>
  </React.StrictMode>
);

reportWebVitals();
